// @ts-nocheck
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import whoWe from '../images/who-we.jpg';
import icon from '../images/icon.png';
import bosco from '../images/ivan-bosco.jpg';

const SalezianyUKR = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <div className="bg-grey">
          <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414]">Салезіяни в Україні</h1>
        </div>
        <div className="text-justify hyphens-auto" id="section3">
          <div className="pt-3 pb-3">
            Задум створення візантійсько-української вітки Салезіянського Згромадження виник у 1930 році з ініціативи митрополита Андрея Шептицького та Папи Пія XI. Вони прагнули впливати на українську молодь через катехизацію та виховання у дусі салезіянської педагогіки.          </div>
          <div className="pt-3 pb-3">
            У 1932 році, за дорученням і підтримкою митрополита Андрея Шептицького та блаженного Йосафата Коциловського, на салезіянську формацію до Італії вирушила перша група українських юнаків, а згодом — ще три: у 1937, 1938 та 1939 роках.          </div>
          <div className="pt-3 pb-3">
            Серед найвідоміших українських салезіян — отець Степан Чміль, перший український салезіянин; владика Андрій Сапеляк, перший український єпископ цього Згромадження та перший єпископ для українців греко-католиків в Аргентині, а також останній український єпископ, який брав участь у Другому Ватиканському Соборі (1962–1965); владика Максим Рябуха, правлячий єпископ Донецького Екзархату, інтронізація якого відбулась 2024 року.
          </div>
          <div className="pt-3 pb-3">
            На жаль, через політичну ситуацію в Україні після Другої світової війни, частина перших українських салезіян змогла повернутися на Батьківщину лише після понад шістдесяти років перебування за кордоном — у 1991 році.          </div>
          <div className="pt-3 pb-3">
            Нині українські спільноти салезіян УГКЦ діють у Львові (3), Києві та місійними станицями у Дніпрі та у Новосілці.
          </div>
        </div>
      </div>
    </>
  );
};

export default SalezianyUKR;
